import { render, staticRenderFns } from "./fishingParadise.vue?vue&type=template&id=065b3945"
import script from "./fishingParadise.vue?vue&type=script&lang=js"
export * from "./fishingParadise.vue?vue&type=script&lang=js"
import style0 from "./fishingParadise.vue?vue&type=style&index=0&id=065b3945&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports